import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Tabs, Tab } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

function BlogSectionTabs({ tabs, selectedTab }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const variant = isSmallScreen ? 'scrollable' : null;
  const tabValue = tabs.findIndex((t) => t.id === selectedTab);
  return (
    <Tabs
      variant={variant}
      value={tabValue}
      indicatorColor="primary"
      scrollButtons="on"
      aria-label="tabs"
    >
      {(tabs || []).map(({ id, label, to }, i) => (
        <Tab
          key={`tab_${id}_${i}`}
          label={label}
          component={Link}
          to={to}
        />
      ))}
    </Tabs>
  );
}

BlogSectionTabs.propTypes = {
  tabs: PropTypes.array,
  selectedTab: PropTypes.string,
};

BlogSectionTabs.defaultProps = {
  tabs: [
    {
      id: 'blog',
      label: 'Blog',
      to: '/blog',
    },
    // {
    //   id: 'news',
    //   label: 'News',
    //   to: '/blog/section/news',
    // },
    // {
    //   id: 'product',
    //   label: 'Product',
    //   to: '/blog/section/product',
    // },
  ],
  selectedTab: 'blog',
};

export default BlogSectionTabs;
